import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import props.
import {
	CommandProps,
} from '@app/props';

interface UseCommandPropsFromRouterResult extends CommandProps {

}

const useCommandPropsFromRouter = (): UseCommandPropsFromRouterResult => {
	const params = useParams();

	// Parse out the router parameters for command props.
	const action: string = React.useMemo(() => {
		return params['action'] ?? String.empty();
	}, [params]);
	const returnUrl: string = React.useMemo(() => {
		return params['returnUrl'] ?? String.empty();
	}, [params]);
	const userId: number = React.useMemo(() => {
		return isNaN(params['userId'])
			? 0
			: parseInt(params['userId'], 10);
	}, [params]);

	return {
		action,
		returnUrl,
		userId,
	};
}

// Export results.
export {
	UseCommandPropsFromRouterResult,
}

export default useCommandPropsFromRouter;